
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    if (location.pathname !== '/') {
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        element?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 right-0 left-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-luxury-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 lg:px-20">
        <div className="flex items-center justify-between h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-4 group">
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/5e6df9ce5b9899c6272cf68673fdbb8b.png"
                alt="فخامة الرفاهية للتوصيل"
                className="h-20 w-auto object-contain transition-all duration-500 group-hover:scale-110 drop-shadow-2xl"
              />
            </div>
          </Link>

          {/* Navigation Links */}
          <div className="hidden lg:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-white font-tajawal text-base hover:text-gold transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              عن المؤسسة
            </button>
            <Link
              to="/services"
              className="text-white font-tajawal text-base hover:text-gold transition-colors duration-300 whitespace-nowrap"
            >
              خدماتنا
            </Link>
            <button
              onClick={() => scrollToSection('videos-gallery')}
              className="text-white font-tajawal text-base hover:text-gold transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              معرض الفيديوهات
            </button>
            <Link
              to="/booking"
              className="text-white font-tajawal text-base hover:text-gold transition-colors duration-300 whitespace-nowrap"
            >
              احجز الآن
            </Link>
            <Link
              to="/contact"
              className="text-white font-tajawal text-base hover:text-gold transition-colors duration-300 whitespace-nowrap"
            >
              اتصل بنا
            </Link>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="text-white font-tajawal text-base hover:text-gold transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              آراء العملاء
            </button>
            <button
              onClick={() => scrollToSection('statistics')}
              className="text-white font-tajawal text-base hover:text-gold transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              الإحصائيات
            </button>
          </div>

          {/* CTA Buttons */}
          <div className="flex items-center gap-3">
            <a
              href="https://wa.me/966XXXXXXXXX"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center bg-green-500 hover:bg-green-600 rounded-full transition-all duration-300 hover:scale-110 cursor-pointer"
            >
              <i className="ri-whatsapp-line text-white text-xl"></i>
            </a>
            <Link
              to="/booking"
              className="hidden lg:flex items-center gap-2 bg-gradient-to-l from-gold to-gold-dark text-luxury-black font-cairo font-bold px-6 py-3 rounded-full hover:shadow-lg hover:shadow-gold/50 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              احجز الآن
              <i className="ri-arrow-left-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
